.cookieManager {
  font-size: 0.9rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.category {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-card);
  overflow: hidden;
}

.categoryHeader {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--color-border);
}

.categoryText {
  display: flex;
  flex: 1 1 20rem;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}

.categoryControl {
  display: flex;
  flex: 0 0 auto;
  gap: 0.75rem;
  align-items: center;
}

.cookieList {
  display: flex;
  flex-direction: column;
}

.cookie {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.5rem;

  &:not(:last-child) {
    border-bottom: 1px solid var(--color-border);
  }
}

.cookieMeta {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 250px;
  max-width: 100%;
  overflow-wrap: anywhere;
}

.cookieDescription {
  flex: 1 1 20rem;
  min-width: 0;
}
